module.exports = __webpack_public_path__ + "img/arrow-right-blue.16488ba0.svg";